import { useEffect, useState } from "react";
import { useCompetitions } from "../../context/CompetitionsContext";
import { CompetitionStats } from "./view/competition-stats";
import { CompetitionWithStats } from "../../types/competition.types";
import { useNavigate } from "react-router-dom";
import { CompetitionsAPI } from "../../APIs/competitions.api";
import { useErrorHandler } from "../../hooks/useErrorHandler";
import { ErrorMessage } from "../../components/error-message";
import { Loading } from "../../components/loading";

export function CurrentCompetitionAdmins() {
  const { currentCompetitionId } = useCompetitions();
  const [competition, setCompetition] = useState<CompetitionWithStats | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const { error, handleError, clearError } = useErrorHandler();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentCompetitionId) return;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        clearError();

        const numberId = Number(currentCompetitionId);
        if (isNaN(numberId)) {
          handleError("No hay una competencia seleccionada.", {
            persist: true,
          });
          return;
        }

        const compResponse = await CompetitionsAPI.getCompetition(numberId);
        if (compResponse.statusCode !== 200) {
          handleError("No se encontró la competencia.", { persist: true });
          return;
        }

        setCompetition(await compResponse.data);
      } catch (err) {
        handleError("Error de conexión, intente nuevamente.", {
          persist: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentCompetitionId, navigate, handleError, clearError]);

  if (isLoading) return <Loading />;

  if (error) return <ErrorMessage message={error} />;

  if (!competition)
    return <ErrorMessage message="No hay una competencia disponible." />;

  return (
    <div className="p-8">
      <CompetitionStats competition={competition} />
    </div>
  );
}
